export default __webpack_public_path__ + "01503a4c071e91d27712020e9babbfd2.png";